// Public GCS-hosted build. Updated by `bash scripts/package-extension.sh --upload`
// from a maintainer machine — testers always pull the latest from this URL.
const EXTENSION_DOWNLOAD_URL = 'https://storage.googleapis.com/tweetvia-extension/tweetvia-extension-latest.zip';

export function Extension() {
  return (
    <div className="page">
      <div className="page-head">
        <h1>Chrome extension</h1>
        <p className="lede">
          Click tweetvia from any page — Hacker News, TechCrunch, Substack, x.com — and get a tweet drafted in your voice, ready to post.
        </p>
      </div>

      <div className="card highlight">
        <h3>What it does</h3>
        <ul className="bullet-list">
          <li>Reads the page you're on (title, summary, anything you highlight).</li>
          <li>Drafts a tweet in your voice using the Ranking Playbook.</li>
          <li>One click → opens X's composer pre-filled. On x.com it inserts directly.</li>
          <li>Captures notable tweets into your Engage feed as you scroll X search.</li>
          <li>Never auto-posts. You always hit Post.</li>
        </ul>
      </div>

      <div className="card">
        <h3>Install</h3>
        <ol className="bullet-list" style={{ paddingLeft: 16 }}>
          <li>
            <a href={EXTENSION_DOWNLOAD_URL} download>Download the extension zip</a>
            {' '}— ~60 KB.
          </li>
          <li>Unzip it somewhere stable (e.g. <code>~/Applications/tweetvia-extension/</code>). Don't delete the folder later — Chrome loads from it.</li>
          <li>Open <a href="#" onClick={(e) => { e.preventDefault(); window.open('chrome://extensions', '_blank'); }}>chrome://extensions</a>.</li>
          <li>Toggle <strong>Developer mode</strong> (top right).</li>
          <li>Click <strong>Load unpacked</strong> and select the unzipped folder.</li>
          <li>Pin tweetvia from the puzzle-piece menu so the icon is always visible.</li>
        </ol>
        <div className="button-row" style={{ marginTop: 12 }}>
          <a href={EXTENSION_DOWNLOAD_URL} download>
            <button className="primary">Download extension zip →</button>
          </a>
        </div>
        <p className="helper" style={{ marginTop: 12 }}>
          On first install, a sign-in tab opens automatically. After that you're connected forever — every click drafts instantly.
        </p>
      </div>

      <div className="card subtle">
        <h3>Chrome Web Store (coming soon)</h3>
        <p className="muted small" style={{ margin: 0 }}>
          We'll publish to the Web Store once we're out of private beta — auto-updates and no Developer mode. For now, load unpacked from the link above.
        </p>
      </div>
    </div>
  );
}
